export const MODERATION_NOTIFY_EMAILS = [
  "m.oleinik@programmatic.ru",
  "e.usikova@programmatic.ru",
  "v.kochmarev@retargeo.ru",
  "s.korolev@programmatic.ru",
  "t.davydova@programmatic.ru",
  "superadmin@example.com",
];

export const isModerationNotifier = (email) =>
  MODERATION_NOTIFY_EMAILS.includes((email || "").toLowerCase());

export const MODERATION_POLL_INTERVAL_MS = 60000;
export const MODERATION_KNOWN_IDS_KEY = "moderation_known_campaign_ids";
